import React from "react";
import { ManageCompensationContainer } from "../../../containers";

const ManageCompensation = (props) => {
  return <ManageCompensationContainer {...props} />;
};

export default ManageCompensation;
